import locale from "localization/en";

export const deliveryLogColumns = [
  { key: "deliveryId", text: locale.deliveryId, width: "200px" },
  {
    key: "shiftDate",
    text: locale.shiftDateAndTime,
    style: {
      width: "auto",
      minWidth: "200px",
    },
  },
  {
    key: "deliveredAt",
    text: locale.deliveryDateAndTime,
    style: {
      width: "110px",
    },
  },
  { key: "poReferenceNumber", text: locale.poReferenceNumber },
  { key: "plateNumber", text: locale.plateNumber },
  { key: "cashier", text: locale.cashier },
  { key: "productType", text: locale.productType },
  { key: "action", text: locale.action },
];
